/**
 * @file 积分充值弹窗 - 顶部用户信息区
 * @description 展示头像 / 昵称 / 会员等级徽章 / 到期时间 + 剩余积分
 */
import styles from './index.module.less';
import LevelBadge from '@/commerce/components/LevelBadge';
import Icon from '@/components/common/Icon';
import {createCx} from '@/utils/cx';
import {formatUnixDate} from '@/utils/date';
import {usePersonalPoints} from '@/hooks/points/usePersonalPoints';
import {useAuthStore} from '@/store/useAuthStore';
import {useMemberInfo} from '@/commerce/benefit';

const cx = createCx(styles);

const UserHeader: React.FC = () => {
    const userInfo = useAuthStore((s) => s.userInfo);
    const {memberInfo} = useMemberInfo();
    const {personalTotalRemaining} = usePersonalPoints();

    const nickname = userInfo?.displayName ?? '';
    const avatar = userInfo?.portrait;

    return (
        <div className={cx('root')}>
            <div className={cx('left')}>
                {avatar ? (
                    <img className={cx('avatar')} src={avatar} alt={nickname} />
                ) : (
                    <div className={cx('avatar', 'avatarPlaceholder')} />
                )}
                <div className={cx('info')}>
                    <div className={cx('name')}>{nickname || '--'}</div>
                    {memberInfo && (
                        <div className={cx('meta')}>
                            <LevelBadge memberInfo={memberInfo} />
                            {!!memberInfo.endTime && (
                                <span className={cx('expire')}>
                                    {formatUnixDate(memberInfo.endTime)}到期
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className={cx('right')}>
                <span className={cx('remainingLabel')}>剩余积分</span>
                <span className={cx('remainingValue')}>
                    <Icon name="AijBasicJifen" size={14} className={cx('remainingIcon')} />
                    {personalTotalRemaining ?? 0}
                </span>
            </div>
        </div>
    );
};

export default UserHeader;
